export interface LevelTwoConfig {
  newLogin: boolean;
  newProfile: boolean;
  newFeedback: boolean;
  newFavorites: boolean;
  newDependents: boolean;
  newAppointments: boolean;
}

export const DEFAULT_LEVEL_TWO_CONFIG: LevelTwoConfig = {
  newLogin: false,
  newProfile: false,
  newFeedback: false,
  newFavorites: false,
  newDependents: false,
  newAppointments: false,
} as const;

export interface VariantFlagEvaluationResult<T = unknown> {
  key: string;
  variant: string | null;
  attachment: T | null;
  match: boolean;
  isFallback: boolean;
  timestamp: number;
  reason?: string;
  evaluationTimeMs?: number;
  errorCode?: string;
  errorMessage?: string;
}

export interface UseLevelTwoResult {
  config: LevelTwoConfig;
  loading: boolean;
  error: Error | null;
  isFallback: boolean;
  refetch: () => Promise<void>;
  variant: string | null;
}
